export default {"id":"58967062","attrs":{"viewBox":"0 0 12 12","width":"12","height":"12"}}